import { Injectable } from "@angular/core";
import { StaffExpenseCategoriesService } from "lib-klab-sdks";
import { map, Observable } from "rxjs";
import { ExpenseCategoriesPort } from "../../../app/ports/accounting/expense-categories.port";
import { ExpenseCategory } from "../../../domain/models/accounting/expense-category.model";
import { mapExpenseCategory } from "../../mappers/accounting/expense-category.mapper";

@Injectable({ providedIn: "root" })
export class ExpenseCategoriesPortAdapter implements ExpenseCategoriesPort {
  constructor(private readonly api: StaffExpenseCategoriesService) {}

  list(companyId?: number): Observable<readonly ExpenseCategory[]> {
    return this.api.list(companyId).pipe(map(({ data }) => (data ?? []).map(mapExpenseCategory)));
  }
}
